module.exports = __webpack_public_path__ + "static/img/celoscope-7.2979244.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-7.jpg
// module id = 7YV1
// module chunks = 51